/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicImport } from './routes/_public'
import { Route as PrivateImport } from './routes/_private'
import { Route as IndexImport } from './routes/index'
import { Route as PublicSignUpImport } from './routes/_public/sign-up'
import { Route as PublicSignInImport } from './routes/_public/sign-in'
import { Route as PublicResetPasswordImport } from './routes/_public/reset-password'
import { Route as PublicRegisterDetailsImport } from './routes/_public/register-details'
import { Route as PublicRegisterImport } from './routes/_public/register'
import { Route as PublicLoginImport } from './routes/_public/login'
import { Route as PublicInviteImport } from './routes/_public/invite'
import { Route as PublicForgottenPasswordImport } from './routes/_public/forgotten-password'
import { Route as PublicActivateAccountImport } from './routes/_public/activate-account'
import { Route as PrivateWeeklyPlanningImport } from './routes/_private/weekly-planning'
import { Route as PrivateTrackExpensesImport } from './routes/_private/track-expenses'
import { Route as PrivateSuppliersImport } from './routes/_private/suppliers'
import { Route as PrivateSettingsImport } from './routes/_private/settings'
import { Route as PrivateRevenueForecast2Import } from './routes/_private/revenue-forecast2'
import { Route as PrivateRevenueForecastImport } from './routes/_private/revenue-forecast'
import { Route as PrivateResourceScheduleImport } from './routes/_private/resource-schedule'
import { Route as PrivateOverheadExpensesImport } from './routes/_private/overhead-expenses'
import { Route as PrivateOrganisationHolidaysImport } from './routes/_private/organisation-holidays'
import { Route as PrivateFeedbackAuthImport } from './routes/_private/feedback-auth'
import { Route as PrivateExpenseReportsImport } from './routes/_private/expense-reports'
import { Route as PrivateBillingImport } from './routes/_private/billing'
import { Route as PrivateTimesheetsIndexImport } from './routes/_private/timesheets.index'
import { Route as PrivateStaffIndexImport } from './routes/_private/staff.index'
import { Route as PrivateStaffRolesIndexImport } from './routes/_private/staff-roles.index'
import { Route as PrivateProjectsIndexImport } from './routes/_private/projects.index'
import { Route as PrivatePermissionsIndexImport } from './routes/_private/permissions.index'
import { Route as PrivateInvoicesIndexImport } from './routes/_private/invoices.index'
import { Route as PrivateCostCentresIndexImport } from './routes/_private/cost-centres.index'
import { Route as PrivateContactsIndexImport } from './routes/_private/contacts.index'
import { Route as PrivateTimesheetsReportImport } from './routes/_private/timesheets.report'
import { Route as PrivateTimesheetsCalendarImport } from './routes/_private/timesheets.calendar'
import { Route as PrivateStaffIdImport } from './routes/_private/staff.$id'
import { Route as PrivateStaffRolesIdImport } from './routes/_private/staff-roles.$id'
import { Route as PrivateProjectsIdImport } from './routes/_private/projects.$id'
import { Route as PrivatePermissionsIdImport } from './routes/_private/permissions.$id'
import { Route as PrivateMigrateIdImport } from './routes/_private/migrate.$id'
import { Route as PrivateImpersonateEmailImport } from './routes/_private/impersonate.$email'
import { Route as PrivateCostCentresIdImport } from './routes/_private/cost-centres.$id'
import { Route as PrivateContactsIdImport } from './routes/_private/contacts.$id'
import { Route as PrivateAccountingAuthImport } from './routes/_private/accounting.auth'
import { Route as PrivateInvoicesIdIndexImport } from './routes/_private/invoices.$id.index'
import { Route as PrivateInvoicesIdPdfImport } from './routes/_private/invoices.$id.pdf'

// Create/Update Routes

const PublicRoute = PublicImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const PrivateRoute = PrivateImport.update({
  id: '/_private',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PublicSignUpRoute = PublicSignUpImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => PublicRoute,
} as any)

const PublicSignInRoute = PublicSignInImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicRoute,
} as any)

const PublicResetPasswordRoute = PublicResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)

const PublicRegisterDetailsRoute = PublicRegisterDetailsImport.update({
  id: '/register-details',
  path: '/register-details',
  getParentRoute: () => PublicRoute,
} as any)

const PublicRegisterRoute = PublicRegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => PublicRoute,
} as any)

const PublicLoginRoute = PublicLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)

const PublicInviteRoute = PublicInviteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => PublicRoute,
} as any)

const PublicForgottenPasswordRoute = PublicForgottenPasswordImport.update({
  id: '/forgotten-password',
  path: '/forgotten-password',
  getParentRoute: () => PublicRoute,
} as any)

const PublicActivateAccountRoute = PublicActivateAccountImport.update({
  id: '/activate-account',
  path: '/activate-account',
  getParentRoute: () => PublicRoute,
} as any)

const PrivateWeeklyPlanningRoute = PrivateWeeklyPlanningImport.update({
  id: '/weekly-planning',
  path: '/weekly-planning',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateTrackExpensesRoute = PrivateTrackExpensesImport.update({
  id: '/track-expenses',
  path: '/track-expenses',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateSuppliersRoute = PrivateSuppliersImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateSettingsRoute = PrivateSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateRevenueForecast2Route = PrivateRevenueForecast2Import.update({
  id: '/revenue-forecast2',
  path: '/revenue-forecast2',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateRevenueForecastRoute = PrivateRevenueForecastImport.update({
  id: '/revenue-forecast',
  path: '/revenue-forecast',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateResourceScheduleRoute = PrivateResourceScheduleImport.update({
  id: '/resource-schedule',
  path: '/resource-schedule',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateOverheadExpensesRoute = PrivateOverheadExpensesImport.update({
  id: '/overhead-expenses',
  path: '/overhead-expenses',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateOrganisationHolidaysRoute =
  PrivateOrganisationHolidaysImport.update({
    id: '/organisation-holidays',
    path: '/organisation-holidays',
    getParentRoute: () => PrivateRoute,
  } as any)

const PrivateFeedbackAuthRoute = PrivateFeedbackAuthImport.update({
  id: '/feedback-auth',
  path: '/feedback-auth',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateExpenseReportsRoute = PrivateExpenseReportsImport.update({
  id: '/expense-reports',
  path: '/expense-reports',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateBillingRoute = PrivateBillingImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateTimesheetsIndexRoute = PrivateTimesheetsIndexImport.update({
  id: '/timesheets/',
  path: '/timesheets/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateStaffIndexRoute = PrivateStaffIndexImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateStaffRolesIndexRoute = PrivateStaffRolesIndexImport.update({
  id: '/staff-roles/',
  path: '/staff-roles/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateProjectsIndexRoute = PrivateProjectsIndexImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivatePermissionsIndexRoute = PrivatePermissionsIndexImport.update({
  id: '/permissions/',
  path: '/permissions/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateInvoicesIndexRoute = PrivateInvoicesIndexImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateCostCentresIndexRoute = PrivateCostCentresIndexImport.update({
  id: '/cost-centres/',
  path: '/cost-centres/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateContactsIndexRoute = PrivateContactsIndexImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateTimesheetsReportRoute = PrivateTimesheetsReportImport.update({
  id: '/timesheets/report',
  path: '/timesheets/report',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateTimesheetsCalendarRoute = PrivateTimesheetsCalendarImport.update({
  id: '/timesheets/calendar',
  path: '/timesheets/calendar',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateStaffIdRoute = PrivateStaffIdImport.update({
  id: '/staff/$id',
  path: '/staff/$id',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateStaffRolesIdRoute = PrivateStaffRolesIdImport.update({
  id: '/staff-roles/$id',
  path: '/staff-roles/$id',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateProjectsIdRoute = PrivateProjectsIdImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivatePermissionsIdRoute = PrivatePermissionsIdImport.update({
  id: '/permissions/$id',
  path: '/permissions/$id',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateMigrateIdRoute = PrivateMigrateIdImport.update({
  id: '/migrate/$id',
  path: '/migrate/$id',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateImpersonateEmailRoute = PrivateImpersonateEmailImport.update({
  id: '/impersonate/$email',
  path: '/impersonate/$email',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateCostCentresIdRoute = PrivateCostCentresIdImport.update({
  id: '/cost-centres/$id',
  path: '/cost-centres/$id',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateContactsIdRoute = PrivateContactsIdImport.update({
  id: '/contacts/$id',
  path: '/contacts/$id',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateAccountingAuthRoute = PrivateAccountingAuthImport.update({
  id: '/accounting/auth',
  path: '/accounting/auth',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateInvoicesIdIndexRoute = PrivateInvoicesIdIndexImport.update({
  id: '/invoices/$id/',
  path: '/invoices/$id/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateInvoicesIdPdfRoute = PrivateInvoicesIdPdfImport.update({
  id: '/invoices/$id/pdf',
  path: '/invoices/$id/pdf',
  getParentRoute: () => PrivateRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicImport
      parentRoute: typeof rootRoute
    }
    '/_private/billing': {
      id: '/_private/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof PrivateBillingImport
      parentRoute: typeof PrivateImport
    }
    '/_private/expense-reports': {
      id: '/_private/expense-reports'
      path: '/expense-reports'
      fullPath: '/expense-reports'
      preLoaderRoute: typeof PrivateExpenseReportsImport
      parentRoute: typeof PrivateImport
    }
    '/_private/feedback-auth': {
      id: '/_private/feedback-auth'
      path: '/feedback-auth'
      fullPath: '/feedback-auth'
      preLoaderRoute: typeof PrivateFeedbackAuthImport
      parentRoute: typeof PrivateImport
    }
    '/_private/organisation-holidays': {
      id: '/_private/organisation-holidays'
      path: '/organisation-holidays'
      fullPath: '/organisation-holidays'
      preLoaderRoute: typeof PrivateOrganisationHolidaysImport
      parentRoute: typeof PrivateImport
    }
    '/_private/overhead-expenses': {
      id: '/_private/overhead-expenses'
      path: '/overhead-expenses'
      fullPath: '/overhead-expenses'
      preLoaderRoute: typeof PrivateOverheadExpensesImport
      parentRoute: typeof PrivateImport
    }
    '/_private/resource-schedule': {
      id: '/_private/resource-schedule'
      path: '/resource-schedule'
      fullPath: '/resource-schedule'
      preLoaderRoute: typeof PrivateResourceScheduleImport
      parentRoute: typeof PrivateImport
    }
    '/_private/revenue-forecast': {
      id: '/_private/revenue-forecast'
      path: '/revenue-forecast'
      fullPath: '/revenue-forecast'
      preLoaderRoute: typeof PrivateRevenueForecastImport
      parentRoute: typeof PrivateImport
    }
    '/_private/revenue-forecast2': {
      id: '/_private/revenue-forecast2'
      path: '/revenue-forecast2'
      fullPath: '/revenue-forecast2'
      preLoaderRoute: typeof PrivateRevenueForecast2Import
      parentRoute: typeof PrivateImport
    }
    '/_private/settings': {
      id: '/_private/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PrivateSettingsImport
      parentRoute: typeof PrivateImport
    }
    '/_private/suppliers': {
      id: '/_private/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof PrivateSuppliersImport
      parentRoute: typeof PrivateImport
    }
    '/_private/track-expenses': {
      id: '/_private/track-expenses'
      path: '/track-expenses'
      fullPath: '/track-expenses'
      preLoaderRoute: typeof PrivateTrackExpensesImport
      parentRoute: typeof PrivateImport
    }
    '/_private/weekly-planning': {
      id: '/_private/weekly-planning'
      path: '/weekly-planning'
      fullPath: '/weekly-planning'
      preLoaderRoute: typeof PrivateWeeklyPlanningImport
      parentRoute: typeof PrivateImport
    }
    '/_public/activate-account': {
      id: '/_public/activate-account'
      path: '/activate-account'
      fullPath: '/activate-account'
      preLoaderRoute: typeof PublicActivateAccountImport
      parentRoute: typeof PublicImport
    }
    '/_public/forgotten-password': {
      id: '/_public/forgotten-password'
      path: '/forgotten-password'
      fullPath: '/forgotten-password'
      preLoaderRoute: typeof PublicForgottenPasswordImport
      parentRoute: typeof PublicImport
    }
    '/_public/invite': {
      id: '/_public/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof PublicInviteImport
      parentRoute: typeof PublicImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginImport
      parentRoute: typeof PublicImport
    }
    '/_public/register': {
      id: '/_public/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof PublicRegisterImport
      parentRoute: typeof PublicImport
    }
    '/_public/register-details': {
      id: '/_public/register-details'
      path: '/register-details'
      fullPath: '/register-details'
      preLoaderRoute: typeof PublicRegisterDetailsImport
      parentRoute: typeof PublicImport
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordImport
      parentRoute: typeof PublicImport
    }
    '/_public/sign-in': {
      id: '/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInImport
      parentRoute: typeof PublicImport
    }
    '/_public/sign-up': {
      id: '/_public/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof PublicSignUpImport
      parentRoute: typeof PublicImport
    }
    '/_private/accounting/auth': {
      id: '/_private/accounting/auth'
      path: '/accounting/auth'
      fullPath: '/accounting/auth'
      preLoaderRoute: typeof PrivateAccountingAuthImport
      parentRoute: typeof PrivateImport
    }
    '/_private/contacts/$id': {
      id: '/_private/contacts/$id'
      path: '/contacts/$id'
      fullPath: '/contacts/$id'
      preLoaderRoute: typeof PrivateContactsIdImport
      parentRoute: typeof PrivateImport
    }
    '/_private/cost-centres/$id': {
      id: '/_private/cost-centres/$id'
      path: '/cost-centres/$id'
      fullPath: '/cost-centres/$id'
      preLoaderRoute: typeof PrivateCostCentresIdImport
      parentRoute: typeof PrivateImport
    }
    '/_private/impersonate/$email': {
      id: '/_private/impersonate/$email'
      path: '/impersonate/$email'
      fullPath: '/impersonate/$email'
      preLoaderRoute: typeof PrivateImpersonateEmailImport
      parentRoute: typeof PrivateImport
    }
    '/_private/migrate/$id': {
      id: '/_private/migrate/$id'
      path: '/migrate/$id'
      fullPath: '/migrate/$id'
      preLoaderRoute: typeof PrivateMigrateIdImport
      parentRoute: typeof PrivateImport
    }
    '/_private/permissions/$id': {
      id: '/_private/permissions/$id'
      path: '/permissions/$id'
      fullPath: '/permissions/$id'
      preLoaderRoute: typeof PrivatePermissionsIdImport
      parentRoute: typeof PrivateImport
    }
    '/_private/projects/$id': {
      id: '/_private/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof PrivateProjectsIdImport
      parentRoute: typeof PrivateImport
    }
    '/_private/staff-roles/$id': {
      id: '/_private/staff-roles/$id'
      path: '/staff-roles/$id'
      fullPath: '/staff-roles/$id'
      preLoaderRoute: typeof PrivateStaffRolesIdImport
      parentRoute: typeof PrivateImport
    }
    '/_private/staff/$id': {
      id: '/_private/staff/$id'
      path: '/staff/$id'
      fullPath: '/staff/$id'
      preLoaderRoute: typeof PrivateStaffIdImport
      parentRoute: typeof PrivateImport
    }
    '/_private/timesheets/calendar': {
      id: '/_private/timesheets/calendar'
      path: '/timesheets/calendar'
      fullPath: '/timesheets/calendar'
      preLoaderRoute: typeof PrivateTimesheetsCalendarImport
      parentRoute: typeof PrivateImport
    }
    '/_private/timesheets/report': {
      id: '/_private/timesheets/report'
      path: '/timesheets/report'
      fullPath: '/timesheets/report'
      preLoaderRoute: typeof PrivateTimesheetsReportImport
      parentRoute: typeof PrivateImport
    }
    '/_private/contacts/': {
      id: '/_private/contacts/'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof PrivateContactsIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/cost-centres/': {
      id: '/_private/cost-centres/'
      path: '/cost-centres'
      fullPath: '/cost-centres'
      preLoaderRoute: typeof PrivateCostCentresIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/invoices/': {
      id: '/_private/invoices/'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof PrivateInvoicesIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/permissions/': {
      id: '/_private/permissions/'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof PrivatePermissionsIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/projects/': {
      id: '/_private/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof PrivateProjectsIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/staff-roles/': {
      id: '/_private/staff-roles/'
      path: '/staff-roles'
      fullPath: '/staff-roles'
      preLoaderRoute: typeof PrivateStaffRolesIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/staff/': {
      id: '/_private/staff/'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof PrivateStaffIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/timesheets/': {
      id: '/_private/timesheets/'
      path: '/timesheets'
      fullPath: '/timesheets'
      preLoaderRoute: typeof PrivateTimesheetsIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/invoices/$id/pdf': {
      id: '/_private/invoices/$id/pdf'
      path: '/invoices/$id/pdf'
      fullPath: '/invoices/$id/pdf'
      preLoaderRoute: typeof PrivateInvoicesIdPdfImport
      parentRoute: typeof PrivateImport
    }
    '/_private/invoices/$id/': {
      id: '/_private/invoices/$id/'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof PrivateInvoicesIdIndexImport
      parentRoute: typeof PrivateImport
    }
  }
}

// Create and export the route tree

interface PrivateRouteChildren {
  PrivateBillingRoute: typeof PrivateBillingRoute
  PrivateExpenseReportsRoute: typeof PrivateExpenseReportsRoute
  PrivateFeedbackAuthRoute: typeof PrivateFeedbackAuthRoute
  PrivateOrganisationHolidaysRoute: typeof PrivateOrganisationHolidaysRoute
  PrivateOverheadExpensesRoute: typeof PrivateOverheadExpensesRoute
  PrivateResourceScheduleRoute: typeof PrivateResourceScheduleRoute
  PrivateRevenueForecastRoute: typeof PrivateRevenueForecastRoute
  PrivateRevenueForecast2Route: typeof PrivateRevenueForecast2Route
  PrivateSettingsRoute: typeof PrivateSettingsRoute
  PrivateSuppliersRoute: typeof PrivateSuppliersRoute
  PrivateTrackExpensesRoute: typeof PrivateTrackExpensesRoute
  PrivateWeeklyPlanningRoute: typeof PrivateWeeklyPlanningRoute
  PrivateAccountingAuthRoute: typeof PrivateAccountingAuthRoute
  PrivateContactsIdRoute: typeof PrivateContactsIdRoute
  PrivateCostCentresIdRoute: typeof PrivateCostCentresIdRoute
  PrivateImpersonateEmailRoute: typeof PrivateImpersonateEmailRoute
  PrivateMigrateIdRoute: typeof PrivateMigrateIdRoute
  PrivatePermissionsIdRoute: typeof PrivatePermissionsIdRoute
  PrivateProjectsIdRoute: typeof PrivateProjectsIdRoute
  PrivateStaffRolesIdRoute: typeof PrivateStaffRolesIdRoute
  PrivateStaffIdRoute: typeof PrivateStaffIdRoute
  PrivateTimesheetsCalendarRoute: typeof PrivateTimesheetsCalendarRoute
  PrivateTimesheetsReportRoute: typeof PrivateTimesheetsReportRoute
  PrivateContactsIndexRoute: typeof PrivateContactsIndexRoute
  PrivateCostCentresIndexRoute: typeof PrivateCostCentresIndexRoute
  PrivateInvoicesIndexRoute: typeof PrivateInvoicesIndexRoute
  PrivatePermissionsIndexRoute: typeof PrivatePermissionsIndexRoute
  PrivateProjectsIndexRoute: typeof PrivateProjectsIndexRoute
  PrivateStaffRolesIndexRoute: typeof PrivateStaffRolesIndexRoute
  PrivateStaffIndexRoute: typeof PrivateStaffIndexRoute
  PrivateTimesheetsIndexRoute: typeof PrivateTimesheetsIndexRoute
  PrivateInvoicesIdPdfRoute: typeof PrivateInvoicesIdPdfRoute
  PrivateInvoicesIdIndexRoute: typeof PrivateInvoicesIdIndexRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateBillingRoute: PrivateBillingRoute,
  PrivateExpenseReportsRoute: PrivateExpenseReportsRoute,
  PrivateFeedbackAuthRoute: PrivateFeedbackAuthRoute,
  PrivateOrganisationHolidaysRoute: PrivateOrganisationHolidaysRoute,
  PrivateOverheadExpensesRoute: PrivateOverheadExpensesRoute,
  PrivateResourceScheduleRoute: PrivateResourceScheduleRoute,
  PrivateRevenueForecastRoute: PrivateRevenueForecastRoute,
  PrivateRevenueForecast2Route: PrivateRevenueForecast2Route,
  PrivateSettingsRoute: PrivateSettingsRoute,
  PrivateSuppliersRoute: PrivateSuppliersRoute,
  PrivateTrackExpensesRoute: PrivateTrackExpensesRoute,
  PrivateWeeklyPlanningRoute: PrivateWeeklyPlanningRoute,
  PrivateAccountingAuthRoute: PrivateAccountingAuthRoute,
  PrivateContactsIdRoute: PrivateContactsIdRoute,
  PrivateCostCentresIdRoute: PrivateCostCentresIdRoute,
  PrivateImpersonateEmailRoute: PrivateImpersonateEmailRoute,
  PrivateMigrateIdRoute: PrivateMigrateIdRoute,
  PrivatePermissionsIdRoute: PrivatePermissionsIdRoute,
  PrivateProjectsIdRoute: PrivateProjectsIdRoute,
  PrivateStaffRolesIdRoute: PrivateStaffRolesIdRoute,
  PrivateStaffIdRoute: PrivateStaffIdRoute,
  PrivateTimesheetsCalendarRoute: PrivateTimesheetsCalendarRoute,
  PrivateTimesheetsReportRoute: PrivateTimesheetsReportRoute,
  PrivateContactsIndexRoute: PrivateContactsIndexRoute,
  PrivateCostCentresIndexRoute: PrivateCostCentresIndexRoute,
  PrivateInvoicesIndexRoute: PrivateInvoicesIndexRoute,
  PrivatePermissionsIndexRoute: PrivatePermissionsIndexRoute,
  PrivateProjectsIndexRoute: PrivateProjectsIndexRoute,
  PrivateStaffRolesIndexRoute: PrivateStaffRolesIndexRoute,
  PrivateStaffIndexRoute: PrivateStaffIndexRoute,
  PrivateTimesheetsIndexRoute: PrivateTimesheetsIndexRoute,
  PrivateInvoicesIdPdfRoute: PrivateInvoicesIdPdfRoute,
  PrivateInvoicesIdIndexRoute: PrivateInvoicesIdIndexRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

interface PublicRouteChildren {
  PublicActivateAccountRoute: typeof PublicActivateAccountRoute
  PublicForgottenPasswordRoute: typeof PublicForgottenPasswordRoute
  PublicInviteRoute: typeof PublicInviteRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicRegisterRoute: typeof PublicRegisterRoute
  PublicRegisterDetailsRoute: typeof PublicRegisterDetailsRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSignInRoute: typeof PublicSignInRoute
  PublicSignUpRoute: typeof PublicSignUpRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicActivateAccountRoute: PublicActivateAccountRoute,
  PublicForgottenPasswordRoute: PublicForgottenPasswordRoute,
  PublicInviteRoute: PublicInviteRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicRegisterRoute: PublicRegisterRoute,
  PublicRegisterDetailsRoute: PublicRegisterDetailsRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignInRoute: PublicSignInRoute,
  PublicSignUpRoute: PublicSignUpRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof PublicRouteWithChildren
  '/billing': typeof PrivateBillingRoute
  '/expense-reports': typeof PrivateExpenseReportsRoute
  '/feedback-auth': typeof PrivateFeedbackAuthRoute
  '/organisation-holidays': typeof PrivateOrganisationHolidaysRoute
  '/overhead-expenses': typeof PrivateOverheadExpensesRoute
  '/resource-schedule': typeof PrivateResourceScheduleRoute
  '/revenue-forecast': typeof PrivateRevenueForecastRoute
  '/revenue-forecast2': typeof PrivateRevenueForecast2Route
  '/settings': typeof PrivateSettingsRoute
  '/suppliers': typeof PrivateSuppliersRoute
  '/track-expenses': typeof PrivateTrackExpensesRoute
  '/weekly-planning': typeof PrivateWeeklyPlanningRoute
  '/activate-account': typeof PublicActivateAccountRoute
  '/forgotten-password': typeof PublicForgottenPasswordRoute
  '/invite': typeof PublicInviteRoute
  '/login': typeof PublicLoginRoute
  '/register': typeof PublicRegisterRoute
  '/register-details': typeof PublicRegisterDetailsRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-up': typeof PublicSignUpRoute
  '/accounting/auth': typeof PrivateAccountingAuthRoute
  '/contacts/$id': typeof PrivateContactsIdRoute
  '/cost-centres/$id': typeof PrivateCostCentresIdRoute
  '/impersonate/$email': typeof PrivateImpersonateEmailRoute
  '/migrate/$id': typeof PrivateMigrateIdRoute
  '/permissions/$id': typeof PrivatePermissionsIdRoute
  '/projects/$id': typeof PrivateProjectsIdRoute
  '/staff-roles/$id': typeof PrivateStaffRolesIdRoute
  '/staff/$id': typeof PrivateStaffIdRoute
  '/timesheets/calendar': typeof PrivateTimesheetsCalendarRoute
  '/timesheets/report': typeof PrivateTimesheetsReportRoute
  '/contacts': typeof PrivateContactsIndexRoute
  '/cost-centres': typeof PrivateCostCentresIndexRoute
  '/invoices': typeof PrivateInvoicesIndexRoute
  '/permissions': typeof PrivatePermissionsIndexRoute
  '/projects': typeof PrivateProjectsIndexRoute
  '/staff-roles': typeof PrivateStaffRolesIndexRoute
  '/staff': typeof PrivateStaffIndexRoute
  '/timesheets': typeof PrivateTimesheetsIndexRoute
  '/invoices/$id/pdf': typeof PrivateInvoicesIdPdfRoute
  '/invoices/$id': typeof PrivateInvoicesIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof PublicRouteWithChildren
  '/billing': typeof PrivateBillingRoute
  '/expense-reports': typeof PrivateExpenseReportsRoute
  '/feedback-auth': typeof PrivateFeedbackAuthRoute
  '/organisation-holidays': typeof PrivateOrganisationHolidaysRoute
  '/overhead-expenses': typeof PrivateOverheadExpensesRoute
  '/resource-schedule': typeof PrivateResourceScheduleRoute
  '/revenue-forecast': typeof PrivateRevenueForecastRoute
  '/revenue-forecast2': typeof PrivateRevenueForecast2Route
  '/settings': typeof PrivateSettingsRoute
  '/suppliers': typeof PrivateSuppliersRoute
  '/track-expenses': typeof PrivateTrackExpensesRoute
  '/weekly-planning': typeof PrivateWeeklyPlanningRoute
  '/activate-account': typeof PublicActivateAccountRoute
  '/forgotten-password': typeof PublicForgottenPasswordRoute
  '/invite': typeof PublicInviteRoute
  '/login': typeof PublicLoginRoute
  '/register': typeof PublicRegisterRoute
  '/register-details': typeof PublicRegisterDetailsRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-up': typeof PublicSignUpRoute
  '/accounting/auth': typeof PrivateAccountingAuthRoute
  '/contacts/$id': typeof PrivateContactsIdRoute
  '/cost-centres/$id': typeof PrivateCostCentresIdRoute
  '/impersonate/$email': typeof PrivateImpersonateEmailRoute
  '/migrate/$id': typeof PrivateMigrateIdRoute
  '/permissions/$id': typeof PrivatePermissionsIdRoute
  '/projects/$id': typeof PrivateProjectsIdRoute
  '/staff-roles/$id': typeof PrivateStaffRolesIdRoute
  '/staff/$id': typeof PrivateStaffIdRoute
  '/timesheets/calendar': typeof PrivateTimesheetsCalendarRoute
  '/timesheets/report': typeof PrivateTimesheetsReportRoute
  '/contacts': typeof PrivateContactsIndexRoute
  '/cost-centres': typeof PrivateCostCentresIndexRoute
  '/invoices': typeof PrivateInvoicesIndexRoute
  '/permissions': typeof PrivatePermissionsIndexRoute
  '/projects': typeof PrivateProjectsIndexRoute
  '/staff-roles': typeof PrivateStaffRolesIndexRoute
  '/staff': typeof PrivateStaffIndexRoute
  '/timesheets': typeof PrivateTimesheetsIndexRoute
  '/invoices/$id/pdf': typeof PrivateInvoicesIdPdfRoute
  '/invoices/$id': typeof PrivateInvoicesIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_private': typeof PrivateRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_private/billing': typeof PrivateBillingRoute
  '/_private/expense-reports': typeof PrivateExpenseReportsRoute
  '/_private/feedback-auth': typeof PrivateFeedbackAuthRoute
  '/_private/organisation-holidays': typeof PrivateOrganisationHolidaysRoute
  '/_private/overhead-expenses': typeof PrivateOverheadExpensesRoute
  '/_private/resource-schedule': typeof PrivateResourceScheduleRoute
  '/_private/revenue-forecast': typeof PrivateRevenueForecastRoute
  '/_private/revenue-forecast2': typeof PrivateRevenueForecast2Route
  '/_private/settings': typeof PrivateSettingsRoute
  '/_private/suppliers': typeof PrivateSuppliersRoute
  '/_private/track-expenses': typeof PrivateTrackExpensesRoute
  '/_private/weekly-planning': typeof PrivateWeeklyPlanningRoute
  '/_public/activate-account': typeof PublicActivateAccountRoute
  '/_public/forgotten-password': typeof PublicForgottenPasswordRoute
  '/_public/invite': typeof PublicInviteRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/register': typeof PublicRegisterRoute
  '/_public/register-details': typeof PublicRegisterDetailsRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/sign-in': typeof PublicSignInRoute
  '/_public/sign-up': typeof PublicSignUpRoute
  '/_private/accounting/auth': typeof PrivateAccountingAuthRoute
  '/_private/contacts/$id': typeof PrivateContactsIdRoute
  '/_private/cost-centres/$id': typeof PrivateCostCentresIdRoute
  '/_private/impersonate/$email': typeof PrivateImpersonateEmailRoute
  '/_private/migrate/$id': typeof PrivateMigrateIdRoute
  '/_private/permissions/$id': typeof PrivatePermissionsIdRoute
  '/_private/projects/$id': typeof PrivateProjectsIdRoute
  '/_private/staff-roles/$id': typeof PrivateStaffRolesIdRoute
  '/_private/staff/$id': typeof PrivateStaffIdRoute
  '/_private/timesheets/calendar': typeof PrivateTimesheetsCalendarRoute
  '/_private/timesheets/report': typeof PrivateTimesheetsReportRoute
  '/_private/contacts/': typeof PrivateContactsIndexRoute
  '/_private/cost-centres/': typeof PrivateCostCentresIndexRoute
  '/_private/invoices/': typeof PrivateInvoicesIndexRoute
  '/_private/permissions/': typeof PrivatePermissionsIndexRoute
  '/_private/projects/': typeof PrivateProjectsIndexRoute
  '/_private/staff-roles/': typeof PrivateStaffRolesIndexRoute
  '/_private/staff/': typeof PrivateStaffIndexRoute
  '/_private/timesheets/': typeof PrivateTimesheetsIndexRoute
  '/_private/invoices/$id/pdf': typeof PrivateInvoicesIdPdfRoute
  '/_private/invoices/$id/': typeof PrivateInvoicesIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/billing'
    | '/expense-reports'
    | '/feedback-auth'
    | '/organisation-holidays'
    | '/overhead-expenses'
    | '/resource-schedule'
    | '/revenue-forecast'
    | '/revenue-forecast2'
    | '/settings'
    | '/suppliers'
    | '/track-expenses'
    | '/weekly-planning'
    | '/activate-account'
    | '/forgotten-password'
    | '/invite'
    | '/login'
    | '/register'
    | '/register-details'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/accounting/auth'
    | '/contacts/$id'
    | '/cost-centres/$id'
    | '/impersonate/$email'
    | '/migrate/$id'
    | '/permissions/$id'
    | '/projects/$id'
    | '/staff-roles/$id'
    | '/staff/$id'
    | '/timesheets/calendar'
    | '/timesheets/report'
    | '/contacts'
    | '/cost-centres'
    | '/invoices'
    | '/permissions'
    | '/projects'
    | '/staff-roles'
    | '/staff'
    | '/timesheets'
    | '/invoices/$id/pdf'
    | '/invoices/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/billing'
    | '/expense-reports'
    | '/feedback-auth'
    | '/organisation-holidays'
    | '/overhead-expenses'
    | '/resource-schedule'
    | '/revenue-forecast'
    | '/revenue-forecast2'
    | '/settings'
    | '/suppliers'
    | '/track-expenses'
    | '/weekly-planning'
    | '/activate-account'
    | '/forgotten-password'
    | '/invite'
    | '/login'
    | '/register'
    | '/register-details'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/accounting/auth'
    | '/contacts/$id'
    | '/cost-centres/$id'
    | '/impersonate/$email'
    | '/migrate/$id'
    | '/permissions/$id'
    | '/projects/$id'
    | '/staff-roles/$id'
    | '/staff/$id'
    | '/timesheets/calendar'
    | '/timesheets/report'
    | '/contacts'
    | '/cost-centres'
    | '/invoices'
    | '/permissions'
    | '/projects'
    | '/staff-roles'
    | '/staff'
    | '/timesheets'
    | '/invoices/$id/pdf'
    | '/invoices/$id'
  id:
    | '__root__'
    | '/'
    | '/_private'
    | '/_public'
    | '/_private/billing'
    | '/_private/expense-reports'
    | '/_private/feedback-auth'
    | '/_private/organisation-holidays'
    | '/_private/overhead-expenses'
    | '/_private/resource-schedule'
    | '/_private/revenue-forecast'
    | '/_private/revenue-forecast2'
    | '/_private/settings'
    | '/_private/suppliers'
    | '/_private/track-expenses'
    | '/_private/weekly-planning'
    | '/_public/activate-account'
    | '/_public/forgotten-password'
    | '/_public/invite'
    | '/_public/login'
    | '/_public/register'
    | '/_public/register-details'
    | '/_public/reset-password'
    | '/_public/sign-in'
    | '/_public/sign-up'
    | '/_private/accounting/auth'
    | '/_private/contacts/$id'
    | '/_private/cost-centres/$id'
    | '/_private/impersonate/$email'
    | '/_private/migrate/$id'
    | '/_private/permissions/$id'
    | '/_private/projects/$id'
    | '/_private/staff-roles/$id'
    | '/_private/staff/$id'
    | '/_private/timesheets/calendar'
    | '/_private/timesheets/report'
    | '/_private/contacts/'
    | '/_private/cost-centres/'
    | '/_private/invoices/'
    | '/_private/permissions/'
    | '/_private/projects/'
    | '/_private/staff-roles/'
    | '/_private/staff/'
    | '/_private/timesheets/'
    | '/_private/invoices/$id/pdf'
    | '/_private/invoices/$id/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRoute: PrivateRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.js",
      "children": [
        "/",
        "/_private",
        "/_public"
      ]
    },
    "/": {
      "filePath": "index.js"
    },
    "/_private": {
      "filePath": "_private.js",
      "children": [
        "/_private/billing",
        "/_private/expense-reports",
        "/_private/feedback-auth",
        "/_private/organisation-holidays",
        "/_private/overhead-expenses",
        "/_private/resource-schedule",
        "/_private/revenue-forecast",
        "/_private/revenue-forecast2",
        "/_private/settings",
        "/_private/suppliers",
        "/_private/track-expenses",
        "/_private/weekly-planning",
        "/_private/accounting/auth",
        "/_private/contacts/$id",
        "/_private/cost-centres/$id",
        "/_private/impersonate/$email",
        "/_private/migrate/$id",
        "/_private/permissions/$id",
        "/_private/projects/$id",
        "/_private/staff-roles/$id",
        "/_private/staff/$id",
        "/_private/timesheets/calendar",
        "/_private/timesheets/report",
        "/_private/contacts/",
        "/_private/cost-centres/",
        "/_private/invoices/",
        "/_private/permissions/",
        "/_private/projects/",
        "/_private/staff-roles/",
        "/_private/staff/",
        "/_private/timesheets/",
        "/_private/invoices/$id/pdf",
        "/_private/invoices/$id/"
      ]
    },
    "/_public": {
      "filePath": "_public.js",
      "children": [
        "/_public/activate-account",
        "/_public/forgotten-password",
        "/_public/invite",
        "/_public/login",
        "/_public/register",
        "/_public/register-details",
        "/_public/reset-password",
        "/_public/sign-in",
        "/_public/sign-up"
      ]
    },
    "/_private/billing": {
      "filePath": "_private/billing.js",
      "parent": "/_private"
    },
    "/_private/expense-reports": {
      "filePath": "_private/expense-reports.js",
      "parent": "/_private"
    },
    "/_private/feedback-auth": {
      "filePath": "_private/feedback-auth.js",
      "parent": "/_private"
    },
    "/_private/organisation-holidays": {
      "filePath": "_private/organisation-holidays.js",
      "parent": "/_private"
    },
    "/_private/overhead-expenses": {
      "filePath": "_private/overhead-expenses.js",
      "parent": "/_private"
    },
    "/_private/resource-schedule": {
      "filePath": "_private/resource-schedule.js",
      "parent": "/_private"
    },
    "/_private/revenue-forecast": {
      "filePath": "_private/revenue-forecast.js",
      "parent": "/_private"
    },
    "/_private/revenue-forecast2": {
      "filePath": "_private/revenue-forecast2.js",
      "parent": "/_private"
    },
    "/_private/settings": {
      "filePath": "_private/settings.js",
      "parent": "/_private"
    },
    "/_private/suppliers": {
      "filePath": "_private/suppliers.js",
      "parent": "/_private"
    },
    "/_private/track-expenses": {
      "filePath": "_private/track-expenses.js",
      "parent": "/_private"
    },
    "/_private/weekly-planning": {
      "filePath": "_private/weekly-planning.js",
      "parent": "/_private"
    },
    "/_public/activate-account": {
      "filePath": "_public/activate-account.js",
      "parent": "/_public"
    },
    "/_public/forgotten-password": {
      "filePath": "_public/forgotten-password.js",
      "parent": "/_public"
    },
    "/_public/invite": {
      "filePath": "_public/invite.js",
      "parent": "/_public"
    },
    "/_public/login": {
      "filePath": "_public/login.js",
      "parent": "/_public"
    },
    "/_public/register": {
      "filePath": "_public/register.js",
      "parent": "/_public"
    },
    "/_public/register-details": {
      "filePath": "_public/register-details.js",
      "parent": "/_public"
    },
    "/_public/reset-password": {
      "filePath": "_public/reset-password.js",
      "parent": "/_public"
    },
    "/_public/sign-in": {
      "filePath": "_public/sign-in.js",
      "parent": "/_public"
    },
    "/_public/sign-up": {
      "filePath": "_public/sign-up.js",
      "parent": "/_public"
    },
    "/_private/accounting/auth": {
      "filePath": "_private/accounting.auth.js",
      "parent": "/_private"
    },
    "/_private/contacts/$id": {
      "filePath": "_private/contacts.$id.js",
      "parent": "/_private"
    },
    "/_private/cost-centres/$id": {
      "filePath": "_private/cost-centres.$id.js",
      "parent": "/_private"
    },
    "/_private/impersonate/$email": {
      "filePath": "_private/impersonate.$email.js",
      "parent": "/_private"
    },
    "/_private/migrate/$id": {
      "filePath": "_private/migrate.$id.js",
      "parent": "/_private"
    },
    "/_private/permissions/$id": {
      "filePath": "_private/permissions.$id.js",
      "parent": "/_private"
    },
    "/_private/projects/$id": {
      "filePath": "_private/projects.$id.js",
      "parent": "/_private"
    },
    "/_private/staff-roles/$id": {
      "filePath": "_private/staff-roles.$id.js",
      "parent": "/_private"
    },
    "/_private/staff/$id": {
      "filePath": "_private/staff.$id.js",
      "parent": "/_private"
    },
    "/_private/timesheets/calendar": {
      "filePath": "_private/timesheets.calendar.js",
      "parent": "/_private"
    },
    "/_private/timesheets/report": {
      "filePath": "_private/timesheets.report.js",
      "parent": "/_private"
    },
    "/_private/contacts/": {
      "filePath": "_private/contacts.index.js",
      "parent": "/_private"
    },
    "/_private/cost-centres/": {
      "filePath": "_private/cost-centres.index.js",
      "parent": "/_private"
    },
    "/_private/invoices/": {
      "filePath": "_private/invoices.index.js",
      "parent": "/_private"
    },
    "/_private/permissions/": {
      "filePath": "_private/permissions.index.js",
      "parent": "/_private"
    },
    "/_private/projects/": {
      "filePath": "_private/projects.index.js",
      "parent": "/_private"
    },
    "/_private/staff-roles/": {
      "filePath": "_private/staff-roles.index.js",
      "parent": "/_private"
    },
    "/_private/staff/": {
      "filePath": "_private/staff.index.js",
      "parent": "/_private"
    },
    "/_private/timesheets/": {
      "filePath": "_private/timesheets.index.js",
      "parent": "/_private"
    },
    "/_private/invoices/$id/pdf": {
      "filePath": "_private/invoices.$id.pdf.js",
      "parent": "/_private"
    },
    "/_private/invoices/$id/": {
      "filePath": "_private/invoices.$id.index.js",
      "parent": "/_private"
    }
  }
}
ROUTE_MANIFEST_END */
